import {
  AutoComplete,
  Button,
  Drawer,
  Form,
  Input,
  Modal,
  Select,
  Spin,
  Switch,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import { responseNotification } from "../../utils/notify";
import AddAdminServices from "./AddService";
const { confirm } = Modal;

const AdminServiceList = () => {
  const [form] = Form.useForm();
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [key, setKey] = useState<any>();

  const [selectedServiceForEdit, setSelectedServiceForEdit] =
    useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const loc = useLocation();

  const [serviceData, setServiceData] = useState({
    loading: false,
    data: null,
  });

  const [brandOptions, setBrandOptions] = useState({
    loading: false,
    list: null,
  });

  const getAdminService = useCallback(async () => {
    setServiceData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
    axios
      .get(
        `${encodedUri}/service/by-type?Type=${type}` +
          (key ? `&ServiceName=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setServiceData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setServiceData({ loading: false, data: [] });
        console.error("Feedback Type: Error", err);
      });
  }, [type, key]);

  const getServiceOptions = useCallback(
    async (key) => {
      setBrandOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
      axios
        .get(
          `${encodedUri}/service/by-type?Type=${type}` +
            (key ? `&ServiceName=${key}` : ``),
          // (type ? `&type=${type}` : ``) +
          // (status ? `&status=${status}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setBrandOptions({
            loading: false,
            list: res.data?.services?.map((service: any) => ({
              label: service.name,
              value: service.name,
            })),
          });
        })
        .catch((err) => {
          setBrandOptions({ loading: false, list: [] });
          console.error("Categories: Error", err);
        });
    },
    [type]
  );

  //
  const onStatusChange = async (id, val) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_AUTH_API}/service`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getAdminService();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const onDelete = async (serviceId: any) => {
    await fetch(`${process.env.REACT_APP_AUTH_API}/service/remove-service`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        serviceNameId: serviceId,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.statusCode === 200) {
          responseNotification("Status Updated Successfully", "success");
          getAdminService();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  function showConfirm(serviceId: any) {
    confirm({
      title: "Do you confirm to delete this service?",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        onDelete(serviceId);
      },
      onCancel() {
        console.log("Cancel");
      },
      okText: "Delete",
    });
  }
  //

  useEffect(() => {
    getAdminService();
    getServiceOptions(``);
  }, [getAdminService, getServiceOptions]);

  useEffect(() => {
    if (visible) {
      setSelectedServiceForEdit(undefined);
    }
  }, [visible]);

  useEffect(() => {
    setSelectedServiceForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedServiceForEdit(null);
    getAdminService();
  };

  const reseAllFieldData = () => {
    // setStatus("");
    setKey("");
    setType("");
    form.resetFields();
  };

  return (
    <React.Fragment>
      <TopHeading
        total={
          serviceData?.data?.totalElements ||
          serviceData?.data?.services?.length
        }
        services={serviceData?.data?.services || []}
        refetch={getAdminService}
      />

      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="search" initialValue={key}>
            <AutoComplete
              onSearch={getServiceOptions}
              onSelect={(val) => setKey(val.toString())}
              options={brandOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                brandOptions?.loading ? <Spin size="small" /> : null
              }
              style={{ width: 300 }}
            >
              <Input.Search
                size="large"
                placeholder="Search by Name"
                onSearch={(val) => setKey(val)}
                enterButton
                loading={brandOptions.loading}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>

          {/* <div className="form-group mr-md-2">
                  <Select
                    placeholder="Product Status"
                    onChange={(val) => setStatus(val)}
                    value={status}
                    style={{ minWidth: 300 }}
                  >
                    <Option value={status}>ALL</Option>
                    <Option value={"ACTIVE"}>ACTIVE</Option>
                    <Option value={"INACTIVE"}>INACTIVE</Option>
                  </Select>
                </div> */}
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>

      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Service</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {serviceData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {serviceData?.data?.services?.length ? (
                    serviceData?.data?.services?.map(
                      (service: any, index: any) => (
                        <React.Fragment key={index}>
                          <div className="single-product-wrapper">
                            <div className="single-product">
                              <span className="name">{service?.name}</span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                {service?.type?.replace("_", " ")}
                              </span>
                            </div>
                            <div className="single-product">
                              <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                defaultChecked={service?.isActive}
                                onChange={(val, e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  onStatusChange(service?.id, val);
                                }}
                              />
                            </div>
                            <div className="single-product">
                              <Button
                                type="dashed"
                                shape="round"
                                className="mr-2"
                                onClick={() =>
                                  setSelectedServiceForEdit(service)
                                }
                              >
                                <EditOutlined />
                              </Button>
                              <Button
                                danger
                                type="dashed"
                                shape="round"
                                onClick={() => showConfirm(service?.id)}
                              >
                                <DeleteOutlined />
                              </Button>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Services" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title="Edit Service"
            width={450}
            onClose={onClose}
            visible={selectedServiceForEdit}
          >
            <AddAdminServices
              visibleData={selectedServiceForEdit}
              onCloseMethod={onClose}
            />
          </Drawer>

          <PaginationTwo
            {...serviceData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminServiceList;
